import { render, staticRenderFns } from "./MarginConfirmationBlock.vue?vue&type=template&id=2369634a&scoped=true&"
import script from "./MarginConfirmationBlock.vue?vue&type=script&lang=js&"
export * from "./MarginConfirmationBlock.vue?vue&type=script&lang=js&"
import style0 from "./MarginConfirmationBlock.vue?vue&type=style&index=0&id=2369634a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2369634a",
  null
  
)

export default component.exports